import { WebCoreIoCKeys, IoCContainer, RandomSentenceGeneratorService, SidebarManagerComponent } from 'web-core-src';

//prototype file doesn't contains exports, so we have to include this way to force the content to the build
import './web-core-src/extends/extend.prototypes.include';
import { EventHandler } from './web-core-src/ioc/implentation/event-handler/event-handler.class';
import { NotificationService } from './web-core-src/ioc/implentation/notification-service/notification-service.class';
import { Utils } from './web-core-src/ioc/implentation/utils/utils.class';
import { WebCoreIoCContainer } from './web-core-src/ioc/implentation/web-core-ioc-container/web-core-ioc-container.class';
import { WebsiteConstants } from './web-core-src/ioc/implentation/website-constants/website-constants.class';

//IoCContainer.bind START
IoCContainer.bindSingletonType(WebCoreIoCKeys.INotificationService, NotificationService);
IoCContainer.bindSingletonType(WebCoreIoCKeys.IEventHandler, EventHandler);
IoCContainer.bindSingletonType(WebCoreIoCKeys.IWebsiteConstants, WebsiteConstants);
IoCContainer.bindSingletonType(WebCoreIoCKeys.IUtils, Utils);
IoCContainer.bindSingletonType(WebCoreIoCKeys.IRandomSentenceGenerator, RandomSentenceGeneratorService);
IoCContainer.bindSingletonType(WebCoreIoCKeys.ISidebarManagerComponent, SidebarManagerComponent);
IoCContainer.bindSingletonType(WebCoreIoCKeys.IWebCoreIoCContainer, WebCoreIoCContainer);
//IoCContainer.bind END

export * from './web-core-src';
